export const SEAT_CONFLICT_RECOVERY_STORAGE_KEY = 'seat-conflict-recovery';

export interface SeatConflictRecovery {
  tripId: string;
  routeScheduleId: string;
  busId: string;
  operatorAlias: string;
  selectedBus?: Record<string, unknown>;
}
